import { useQuery } from "react-query";
import { API_KEY_GET_PROJECTS_LIST } from "../utils";
import { getBrandsList } from "../api";

export const useGetBrandsList = () => {
  return useQuery([API_KEY_GET_PROJECTS_LIST], () => getBrandsList());
};
